import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsLearningPathsTabPanel } from '@/analytics/components/AnalyticsLearningPathsTabPanel/AnalyticsLearningPathsTabPanel'
import { TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED } from '@/core/constants/constants'
import { track } from '@/core/utils/tracking/track'

export const Route = createFileRoute(
  '/company/_management/analytics/learning-paths',
)({
  component: AnalyticsLearningPathsTabPanel,
  onEnter: () => {
    track(TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED, {
      dashboard_page: 'learning-paths',
    })
  },
})
